import {
    GET_CARGAS_PREVIAS,
    POST_CARGAR_ARCHIVO
} from '../types';


export default function cargaMasivaReducer(state = {}, action) {
    switch (action.type) {
        case GET_CARGAS_PREVIAS:
            return { ...state, ...action.payload }
        case POST_CARGAR_ARCHIVO:
            return { ...state, archivo: action.payload }
        default:
            return state
    }
}